import { useContext } from 'react'
import { PassContext } from "../../pass-context"
import dataSelector from '../data-selector'
import PopupEditor from '../popup-editor'

const GoogleBackHeader = () => {

  const { classData, objectData, variables, passType } = useContext(PassContext)

  const header = getHeader({ passType, classData, objectData, variables })

  return (
    <div className="flex flex-col">
      <Header header={header} />
    </div>
  )
}

export default GoogleBackHeader

const Header = ({ header }) => {
  if (header.editable) {
    return (
      <PopupEditor title="Header" path={header.path} sources={header.sources} variable="pass.header">
        <div className="header editable">{header.value}</div>
      </PopupEditor>
    )
  } else {
    return (<div className="header">{header.value}</div>)
  }
}

const getHeader = ({ classData, objectData, variables, passType }) => {
  try {
    switch (passType) {
      case "generic":
        {
          return {
            editable: true,
            sources: ["object"],
            path: "header.defaultValue.value",
            value: dataSelector({ objectData, variables, path: "header.defaultValue.value" }) // Mandatory
          }
        }

      case "eventTicket": {
        return {
          editable: true,
          sources: ["class"],
          path: "eventName.defaultValue.value",
          value: dataSelector({ objectData:classData, variables, path: "eventName.defaultValue.value" }) // Mandatory
        }
      }

      case "flight":
        {
          return {
            editable: false,
            value: "" // Mandatory
          }
        }

      case "transit":
        {
          return {
            editable: false,
            value: getTransitHeader({ variables })
          }
        }

      case "offer":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "title",
            value: dataSelector({ objectData:classData, variables, path: "title" }) // Mandatory
          }
        }
      case "loyalty":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "programName",
            value: dataSelector({ objectData:classData, variables, path: "programName" }) // Mandatory
          }
        }

      case "giftCard": {
        return {
          editable: true,
          sources: ["object"],
          path: "balance.micros",
          value: getBalanceHeader({ objectData, variables }) // Mandatory
        }
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}

const getBalanceHeader = ({ objectData, variables }) => {
  const resolvedBalance = dataSelector({ objectData, variables, path: "balance" })
  const microsString = Number(resolvedBalance.micros.toString().replace(/[^0-9.-]+/g,""));
  return "Gift Card: " + microsString.toLocaleString('en-US', { style: 'currency', currency: resolvedBalance.currencyCode, minimumFractionDigits: 0 })
}

const getTransitHeader = ({ variables }) => {

  const legs = variables?.journey?.legs

  if(legs) {
    const resolvedLegs = dataSelector({ objectData: { legs }, variables, path: "legs" })

    let firstLeg = resolvedLegs[0]
    let lastLeg = resolvedLegs[resolvedLegs.length - 1]

    return `${firstLeg.origin.code} to ${lastLeg.destination.code}`
  } else {
    return "Journey data missing from instance data"
  }
}